import {IDynaTime} from "dyna-travel-interfaces";

export const getHour = (time:IDynaTime): number => Number(time.localTime.substr(0,2));